import { BILLING_CONTACT_MODAL as FEATURE_PREFIX } from 'featurePrefix.ids'

export const ModalIds = {
  AddContactButton: `${FEATURE_PREFIX}__add_contact_button`,
  CancelButton: `${FEATURE_PREFIX}__cancel_button`,
  CloseModalButton: `${FEATURE_PREFIX}__close_modal-button`,
  ContactCount: `${FEATURE_PREFIX}__contact_count`,
  ContactForm: (index: number) => `${FEATURE_PREFIX}__contact_form__${index}`,
  ContactFormTitle: (index: number) =>
    `${FEATURE_PREFIX}__contact_form_title__${index}`,
  EmailInput: (index: number) => `${FEATURE_PREFIX}__email_input__${index}`,
  LastUpdated: `${FEATURE_PREFIX}__last_updated`,
  ModalContainer: `${FEATURE_PREFIX}__container`,
  ModalTitle: `${FEATURE_PREFIX}__title`,
  NameInput: (index: number) => `${FEATURE_PREFIX}__name_input__${index}`,
  RemoveContactButton: (index: number) =>
    `${FEATURE_PREFIX}__remove_contact_button__${index}`,
  SaveButton: `${FEATURE_PREFIX}__save_button`,
} as const
